/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{CFBD9884-84B8-478A-8CBE-82A7296AE956}",
  "sitecoreApiHost": "",
  "jssAppName": "hbt-internal-portal",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/hbt-internal-portal",
  "graphQLEndpoint": "/api/hbt-internal-portal?sc_apikey={CFBD9884-84B8-478A-8CBE-82A7296AE956}"
};